import React from "react";

export default function InformationWe() {
  return (
    <>
      <div className="tp-service-area pt-50 tp-btn-trigger">
        <div className="container container-1630">
          <div className="container">
            <div className="text-center">
              <p className="tp-hero-3-category tp_reveal_anim">
                Welcome to Kryptogram. We respect your privacy and are committed
                to protecting your personal information. This Privacy Policy
                outlines how we collect, use, and safeguard data related to your
                use of our NFT marketplace, Kryptogram Island land ownership
                program, and Tribe O Crypto Festival services.
              </p>
              <p className="tp-hero-3-category tp_reveal_anim">
                By using our website and purchasing Kryptogram NFTs, you agree
                to the collection, processing, and use of your data as described
                in this policy.
              </p>
            </div>
          </div>
          <div className="row pt-50">
            <div className="col-xl-12">
              <div className="tp-service-5-title-box text-center">
                <h3 className="tp-hero-3-title tp_reveal_anim ">
                  Information We Collect
                </h3>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12">
              <div className="tp-award-list-wrap">
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-2"
                >
                  <div className="tp-award-list-content-left  align-items-center">
                    <h5 className="pb-10 text-color-yellow">
                      Personal Information{" "}
                    </h5>
                    <p>
                      Name, email address, and phone number (if provided
                      voluntarily for inquiries or support).
                    </p>
                    <p className="pt-10">
                      Wallet address and transaction details when purchasing
                      Kryptogram NFTs.
                    </p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-3"
                >
                  <div className="tp-award-list-content-left  align-items-center">
                    <h5 className="pb-10 text-color-yellow">Usage Data</h5>
                    <p>IP addresses, browser type, and device information.</p>
                    <p className="pt-10">
                      Blockchain transaction history related to Kryptogram NFTs
                      (publicly available on the blockchain).
                    </p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-4"
                >
                  <div className="tp-award-list-content-left  align-items-center">
                    <h5 className="pb-10 text-color-yellow">
                      Cookies & Tracking Technologies{" "}
                    </h5>
                    <p>
                      We use cookies and analytics tools to enhance user
                      experience, monitor website traffic, and improve security.
                    </p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-4"
                >
                  <div className="tp-award-list-content-left  align-items-center">
                    <h5 className="pb-10 text-color-yellow">
                      Providing Customer Support
                    </h5>
                    <p>Responding to user inquiries and resolving issues.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
